import React from 'react'
import FeaturesBox from './featuresbox'
import image2 from '../images/feature_2.png'
import image3 from '../images/feature_3.png'
import image1 from '../images/feature_1.png'
function features() {
    return (
        <div id="features">
            <div className="a-container">
                <FeaturesBox image={image1} title="This is a title"/>
                <FeaturesBox image={image2} title="This is a title"/>
                <FeaturesBox image={image3} title="This is a title"/>
            </div>
        </div>
    )
}

export default features
